const LOGO_URL = "/logo-white.png";
const LOGO_COLOR_URL = "/logo-color.png";

export const Logo = ({ variant = "color", size = "h-12 md:h-14" }) => (
  <span className="relative inline-flex items-center" data-testid="logo-syndicappli360">
    {/* Blanc sur dégradé, couleur sur fond clair — sans pavé */}
    <img
      src={variant === "white" ? LOGO_URL : LOGO_COLOR_URL}
      alt="Syndicappli360 — La seule solution syndic à 360°"
      className={`${size} w-auto`}
    />
  </span>
);
